import { updateBrandPricesAsync, updateShapePricesAsync, updateMaterialPricesAsync, updateProfilePricesAsync } from '../helpers/benchPriceOptionsUpdater';
import { benchModels, benchShapes, stoves } from '../config.js';
import { benchPriceService } from '../helpers/benchPriceService';
import { getBenchMaterial, getPanelMaterial, getBenchMaterials, getProfileMaterials } from '../reducers/materialStore';
import benchPriceStore from '../helpers/priceStore';
import buildDoorName from '../helpers/doorDescriptionBuilder';

let priceStore;

let getPriceStore = (getState) => {
    if (!priceStore) {
        priceStore = new benchPriceStore(buildPriceService(getState));
    }
    return priceStore;
}


export const benchPriceUpdated = (brand, shape, mirrored, material, profileMaterial, price) => {
    
    return { type: 'BENCH_PRICE_UPDATED', brand, shape,mirrored, material, profileMaterial, price };
}



export const updateBenchPriceOptions = () => {
    return (dispatch, getState) => {
        let state = getState();        
            let optionPricing = state.optionPricing;
            let priceStore = getPriceStore(getState);
            updateBrandOptionPrices(state, optionPricing, priceStore, dispatch);
            updateShapeOptionPrices(state, optionPricing, priceStore, dispatch);
            updateMaterialPrices(state, optionPricing, priceStore, dispatch);
            updateProfilePrices(state, optionPricing, priceStore, dispatch);        
    }
}
export const updatePriceStorePrice = (bench, price,getState) => {

    getPriceStore(getState).updatePrice(bench, price);
}


let updateBrandOptionPrices = (state, optionPricing, priceStore, dispatch) => {
    let brands = state.benchModel.availableBenchModels;
    dispatch(benchBrandOptionUpdateStarted());
    let brandPrices = updateBrandPricesAsync(
        getBenchMaterials(state),
        brands.map(m => m.name),
        optionPricing.baseOptions,
        optionPricing.activeOptions,
        priceStore);
    brandPrices.then((prices) => dispatch(benchBrandOptionPricesUpdated(prices)));
}

let updateShapeOptionPrices =
    (state, optionPricing, priceStore, dispatch) => {
    dispatch(benchShapeOptionUpdateStarted());
    let shapes = state.benchModel.availableBenchShapes;
    let shapePrices = updateShapePricesAsync(shapes.map(s => s.code), optionPricing.baseOptions, optionPricing.activeOptions, priceStore);
    shapePrices.then((prices) => dispatch(benchShapeOptionPricesUpdated(prices)));
}


function updateMaterialPrices(state, optionPricing, priceStore, dispatch) {
    dispatch(benchMaterialOptionUpdateStarted());
    let materialPrices = updateMaterialPricesAsync(getBenchMaterials(state).filter(m => m.benchModel.includes(optionPricing.activeOptions.benchBrand)).map(m => m.id), optionPricing.baseOptions, optionPricing.activeOptions, priceStore);
    materialPrices.then((prices) => dispatch(benchMaterialOptionPricesUpdated(prices)));
}

function updateProfilePrices(state, optionPricing, priceStore, dispatch) {
    if (benchModels.find(m => m.name === optionPricing.activeOptions.benchBrand).useProfileLayer) {
        let profilePrices = updateProfilePricesAsync(getProfileMaterials(state).map(m => m.id), optionPricing.baseOptions, optionPricing.activeOptions, priceStore);
        profilePrices.then((prices) =>
            dispatch(profilleMaterialOptionPricesUpdated(prices)
        ));
    }
}




let buildPriceService = (getState) =>
{
    let measurements = getState().measurements;
    return (brand, shape, mirrored, material, profileMaterial) =>
        benchPriceService(brand, shape, mirrored, material,profileMaterial, measurements).then(price => {    
                return price;
            }).then(price => price);
}

export const benchBrandOptionUpdateStarted= () => {
    return {
        type: 'BENCHBRAND_OPTIONPRICES_UPDATE_STARTED'
    };
}
export const benchShapeOptionUpdateStarted = () => {
    return {
        type: 'BENCHSHAPE_OPTIONPRICES_UPDATE_STARTED'
    };
}
export const benchMaterialOptionUpdateStarted = () => {
    return {
        type: 'BENCHMATERIAL_OPTIONPRICES_UPDATE_STARTED'
    };
}

export const benchBrandOptionPricesUpdated = (brandprices) => {
    return {
        type: 'BENCHBRAND_OPTIONPRICES_UPDATED',
        prices: brandprices
    };
}

export const benchShapeOptionPricesUpdated = (shapeprices) => {
    return {
        type: 'BENCHSHAPE_OPTIONPRICES_UPDATED',
        prices: shapeprices
    };
}
export const benchMaterialOptionPricesUpdated = (materialprices) => {
    return {
        type: 'BENCHMATERIAL_OPTIONPRICES_UPDATED',
        prices: materialprices
    };
}
export const profilleMaterialOptionPricesUpdated = (materialprices) => {
    return {
        type: 'PROFILE_OPTIONPRICES_UPDATED',
        prices: materialprices
    };
}
export const glassPriceUpdated = (price) => {
    return  {
        type: 'GLASSPRICE_UPDATED',
        price: price
    };
}

export const updateOptionRows = () => (dispatch, getState) => {
    let state = getState();
    if (state.clientConfiguration.showPrices) {   
        let options = state.optionPricing;
        let baseOptions = options.baseOptions;
        let newOptions = options.activeOptions;
        let result = [];
        if (options.panelPrices) result.push(getPanelChangeRow(baseOptions.panel, newOptions.panel, state));

        getBenchChangeRow(baseOptions, newOptions, state).then(r => {
            result.push(r);
            result.push(getLightChangeRow(baseOptions, newOptions, state));
            result.push(getStoveChangeRow(baseOptions, newOptions, state));
            if (state.clientConfiguration.allowDoorModification) result.push(getDoorChangeRow(baseOptions, newOptions, state));
            dispatch({
                type: 'OPTION_ROWS_UPDATED',
                rows: result
            });
        });
    }
 
}
let getBenchChangeRow = (baseOptions, newOptions, state) => {
    let newPricePromise = getPriceStore(state).getPriceAsync(optionsToPriceStoreBench(newOptions));
    let basePricePromise = getPriceStore(state).getPriceAsync(optionsToPriceStoreBench(baseOptions));
    return Promise.all([newPricePromise, basePricePromise]).then(values => {
        let change = values[0] - values[1];
        let brand = newOptions.benchBrand;
        let shape = benchShapes.filter(s => s.code === newOptions.benchShape)[0].name;
        let material = getBenchMaterial(state, newOptions.benchMaterial).name;
        return {
            description: "Laude: " + brand + " " + shape + " " + material, cost: change
        };
    })
}
let optionsToPriceStoreBench=(options) => {
    return {
        brand: options.benchBrand,
        material: options.benchMaterial,
        shape: options.benchShape,
        mirrored: options.mirrored,
        profilematerial: options.profile
    };
}


let getLightChangeRow = (baseOptions, newOptions, state) => {
    let lightPrices = state.optionPricing.lightPrices;
    if (lightPrices) {
        let baseOption = lightPrices.find(l => l.id === baseOptions.ligth);      
        let basePrice = baseOption ? baseOption.price : 0;
        let newOption = lightPrices.find(l => l.id === newOptions.ligth)
        let newPrice = newOption.price;
        let cost = newPrice - basePrice;       
        return {
            description: "Valaistus:" + newOption.name, cost: cost
        };
    }
    else {
        return { description:"",cost:0};
    }
}

let getStoveChangeRow = (baseOptions, newOptions, state) => {
    let stovePrices = state.optionPricing.stovePrices;
    let cost = 0;
    let stoveName = "";
    if (stovePrices) {
        let basePrice = stovePrices.filter(l => l.id === baseOptions.stove)[0].price;
        let newPrice = stovePrices.filter(l => l.id === newOptions.stove)[0].price;
        cost = newPrice - basePrice;
        stoveName = stoves.filter(s => s.id === newOptions.stove)[0].name;
    }
    return {
        description:"Kiuas: " + stoveName, cost: cost
    };
}


let getPanelChangeRow = (baseId, newPanel, state) => {
    let newMaterial = state.optionPricing.panels[newPanel];
    let defaultMaterial = state.optionPricing.panels[baseId];
    let materialName = getPanelMaterial(state, newPanel).name;
    return {
        description: "Panelointi: " + materialName, cost: newMaterial - defaultMaterial
    };
}

let getDoorChangeRow = (baseOptions, newOptions, state) => {
    let baseDoorPrice = (baseOptions.doorPrice) ? baseOptions.doorPrice:0;
    let newPrice = state.optionPricing.glassPrice;
    let doorName = buildDoorName(state);
    return {
        description: doorName, cost: newPrice - baseDoorPrice
    };
}




